<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <div class="video-top">
      <div class="video-card box">
        <p class="video-card-img"><img src="../../assets/upload/csmp08.png" alt=""></p>
        <div class="video-card-info">
          <h3 class="hide">聆听历史呼唤 读懂千年传承</h3>
          <p class="hide">123人购买 | 1024评论</p>
          <p class="price"><span>￥10</span>/看全部视频</p>
          <button class="btn buy-btn">购买</button>
        </div>
      </div>

      <div class="video-tab">
        <p>推荐</p>
        <p>点赞</p>
        <p>播放</p>
        <div><img src="../../assets/a_03.png" alt="">目录</div>
      </div>
    </div>
  </div>
</template>

<script>

  import {getViewDetail} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {

      }
    },
    computed: {

    },
    created(){

    },
    beforeDestroy(){

    },
    methods: {


    },
    watch:  {

    },
    components: {

    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";

</style>



// WEBPACK FOOTER //
// src/page/view-detail/video-watch.vue